module.exports = __webpack_public_path__ + "img/门禁控制器 (5).8cf0882f.jpg";